module.exports = __webpack_public_path__ + "static/media/third_medal.dd2a36f4.png";